










import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class DevHeaderTime extends Vue {
      selectedDate: Date = new Date();
      selectedHour:number  = new Date().getHours();
      hours = (Array(20 - 7 + 1).fill(0, 0) as number[]).map((_, idx) => 7 + idx)
      setSelectedDate($event: any){
            setTimeout(() => {
                  this.$store.dispatch('setTime',{ date: this.selectedDate})
            },600)
      }
      setSelectedHour(){
            this.$store.dispatch('setTime',{ hour: this.selectedHour})
      }
}
